

































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';

import { Order } from '@/models/order';
import { Product } from '@/models/product';
import { FileType } from '@/models/file-type';
import { OrderComplainModel } from '@/models/order-complain';

import orderService from '@/services/order-service';
import commonService from '@/services/common-services';

import { APP_CONFIG } from '@/config/app-config';

import ListProduct from './components/ListProduct.vue';
import DetailComplain from './components/DetailComplain.vue';
import ChatBox from '@/shared/components/ChatBox.vue';

const numeral = require('numeral');
@Component({
    components: {
        ListProduct,
        DetailComplain,
        Loading,
        'chat-box': ChatBox
    }
})
export default class ComplainOrder extends Vue {
    private order: Order = new Order();
    private complain: OrderComplainModel = new OrderComplainModel();

    private complainOptionValue = {
        indemnity: '',
        content: '',
        complainSelected: [],
        images: [] as FileType[],
        products: [] as Product[]
    };

    private isLoading = false;
    
    get orderId() {
        return this.$route.params.orderId;
    }

    get compainId() {
        return this.$route.params.complainId || 0;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    private async created() {
        this.order.products = [];
        this.order.changedHistories = [];
        this.order.paymentHistory = [];
        this.order.orderComplains = [];

        if(!this.orderId) {
            return this.$router.push({ name: 'order-index' });
        }
        if (!this.rate) {
            await this.getRate();
        }
        await this.getDataComplain();
        await this.loadData();
    }

    private async loadData() {
        const result = await orderService.orderById(this.orderId);
        if (result && result.data && result.data.status === 200) {
            const item = result.data.data;
            this.order = new Order();
            this.order.id = item.ID;
            this.order.amountCNY = item.AmountCNY;
            this.order.amountVND = item.AmountVND;
            this.order.exchangeRate = item.ExchangeRate;
            this.order.status = item.Status;
            this.order.totalAmountVND = item.TotalAmountVND;
            this.order.totalRealAmount = item.TotalRealAmount;
            this.order.totalRealAmountCNY = item.TotalRealAmountCNY;

            this.order.products = [];
            for (const prod of item.Products) {
                const product = new Product();
                product.id = prod.ID;
                product.imageOrigin = prod.image_origin;
                product.linkOrigin = prod.link_origin;
                product.priceOrigin = prod.price_origin;
                product.pricePromotion = prod.price_promotion;
                product.priceOriginVND = prod.price_origin * item.ExchangeRate;
                product.pricePromotionVND = prod.price_promotion * item.ExchangeRate;
                product.amountCN = (prod.price_promotion || prod.price_origin) * prod.quantity; 
                product.property = prod.property;
                product.quantity = prod.quantity;
                product.titleOrigin = prod.title_origin;
                product.isChoose = this.complain.productIds.filter(x => x === prod.ID).length > 0 ? true : false;
                this.order.products.push(product);
                if(product.isChoose) {
                    this.complainOptionValue.products.push(product)
                }
            }
        }
    }

    private async getDataComplain() {
        this.complain.id = numeral(this.compainId).value();
        if (this.complain.id > 0) {
            const result = await orderService.getComplainById(this.complain.id);
            if (result && result.status === 200 && result.data.status === 200) {
                this.mapComplain(result.data.data);
            }
        }
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
        (window['getApp'] as any).$emit('SET_MIN_FEEBUY', result.data.data.min_feebuy);
      }
    }

    private onSubDataInDetail(data: any) {
        this.complainOptionValue = {
            ...this.complainOptionValue,
            indemnity: data.indemnity,
            content: data.content,
            complainSelected: data.complainSelected,
            images: data.images
        };
    }

    private onSubDataInListProduct(data: any) {
        this.complainOptionValue = {
            ...this.complainOptionValue,
            products: data.products
        };
    }

    private async onCancelComplainOrder() {
        this.isLoading = true;
        const dataRequest = {
            Status: 0,
            ProductIds: this.complainOptionValue.products.map((prod: any) => prod.id)
        };
        await orderService.updateComplainOrder(this.complain.id, dataRequest);
        Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thông báo!',
            text: 'Hủy khiếu nại thành công!',
        });
        this.isLoading = false;
        this.$router.push({ name: 'order-detail', params: { orderId: this.orderId.toString() } }).catch(() => {
            return false;
        });
    }

    private async onComplainOrder() {
        if(this.complainOptionValue.products.length === 0) {
             Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Vui lòng chọn sản phẩm khiếu nại!'
            });
        } else {
            this.isLoading = true;
            await this.onUploadImage();
            const result = await this.onAddComplainOrder();
            if (result && result.status === 200 && result.data.status === 200 && this.order.status !== 13) {
                await this.onChangeStatusOrder();
            }
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo khiếu nại thành công!',
            });
            this.isLoading = false;
            if (this.complain.id === 0) {
                this.$router.push({ name: 'order-detail', params: { orderId: this.orderId.toString() } }).catch(() => {
                    return false;
                });
            }
        }
    }

    private async mapComplain(data: any) {
        this.complain = {
            ...this.complain,
            amount: data.Amount,
            amountNDT: data.AmountNDT,
            complainText: data.ComplainText,
            createBy: data.CreatedBy,
            createDate: data.CreatedDate,
            exchangeRate: data.ExchangeRate,
            id: data.ID,
            img: data.IMG,
            isBroken: data.IsBroken === 1,
            isMissGood: data.IsMissGood === 1,
            isOption: data.IsOption === 1,
            isOther: data.IsOther === 1,
            modifiedBy: data.ModifiedBy,
            modifiedDate: data.ModifiedDate,
            noteForUser: data.NoteForUser,
            noteOfStaff: data.NoteOfStaff,
            orderId: data.OrderID,
            orderType: data.OrderType,
            productIds: data.ProductIds,
            receivedId: data.ReceivedID,
            status: data.Status,
            uId: data.UID,
            userName: data.Username
        };
    }

    private async onUploadImage() {
        for(const image of this.complainOptionValue.images) {
            if(image.file === undefined) {
                continue;
            }
            const formData = new FormData();
            formData.append('imagefile', image.file as any);
            formData.append('filename', image.fileName);
            const result = await commonService.uploadFile(formData);
        }
    }

    private async onAddComplainOrder() {
        const amountNDT = numeral(this.complainOptionValue.indemnity.split(',').join('')).value();
        const dataRequest = {
            UID: this.userInfo.userId,
            Username: this.userInfo.userName,
            OrderID: this.order.id,
            ExchangeRate: this.rate,
            Amount: amountNDT * this.rate,
            IMG: this.complainOptionValue.images.reduce((imgs: string, image: any) => {
                const fileName = image.fileName ? image.fileName : (image.src ? image.src.replace(/^.*[\\\/]/, '') : '');
                return imgs + (imgs === '' ? fileName : (';' + fileName))
            }, ''),
            ComplainText: this.complainOptionValue.content,
            Status: 1,
            IsMissGood: this.complainOptionValue.complainSelected.find((x: any) => x.value === 1) ? 1 : 0,
            IsBroken: this.complainOptionValue.complainSelected.find((x: any) => x.value === 2) ? 1 : 0,
            IsOption: this.complainOptionValue.complainSelected.find((x: any) => x.value === 3) ? 1 : 0,
            IsOther: this.complainOptionValue.complainSelected.find((x: any) => x.value === 4) ? 1 : 0,
            ReceivedID: 1,
            AmountNDT: amountNDT,
            NoteOfStaff: '',
            OrderType: '',
            NoteForUser: '',
            ProductIds: this.complainOptionValue.products.map((prod: any) => prod.id)
        };
        if(this.complain.id === 0) {
            return await orderService.complainOrder(dataRequest);
        } else {
            return await orderService.updateComplainOrder(this.complain.id, dataRequest);
        }
    }

    private async onChangeStatusOrder() {
        const dataRequest =  {
            Status: 13
        };
        const result = await orderService.updateOrder(this.order.id, dataRequest);
        
        if (result && result.status === 200 && result.data.status === 200) {
            this.order = {
                ...this.order,
                status: 13
            };
        }
    }
}
